import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import SidebarBody from '../../SidebarBody';
import styles from '../UserProfile.module.scss';
import defaultUserImage from '../../../../assets/img/user-default.png';
import Button from '../../../Button';
import { getConfig } from '../../../../lib/config';
import Switch from 'react-switch';
import actions from './actions';

function UserProfileContent(props) {
  const { profile } = props;

  return (
    <SidebarBody className={styles.userProfile}>
      <div className={styles.userInfo}>
        <div className={styles.avatarContainer}>
          <img
            src={profile.avatar || defaultUserImage}
            className={styles.avatarImage}
          />
        </div>
        <div className={styles.userName}>
          {profile.firstName} {profile.lastName}
        </div>
        <div className={styles.userLocation}>{profile.location}</div>
      </div>
      <div className={styles.profileActions}>
        <a
          href={`${props.appConfig.REACT_APP_GOHUNT_CMS_URL}/user/account`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Button theme={Button.THEME.outlinePrimary}>Account Settings</Button>
        </a>
        <Button theme={Button.THEME.outlinePrimary} onClick={props.showKeyboardShortcuts}>
          Keyboard shortcuts
        </Button>
        <a
          href={getConfig('FEEDBACK_URL')}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Button theme={Button.THEME.outlinePrimary}>Feedback</Button>
        </a>
        <a
          href={`${props.appConfig.REACT_APP_GOHUNT_CMS_URL}/contact`}
          rel="noopener noreferrer"
          target="_blank"
        >
          <Button theme={Button.THEME.outlinePrimary}>Contact Us</Button>
        </a>
        <div className={styles.separator} />
        <Button
          theme={Button.THEME.outlineRed}
          onClick={() => props.logout(props.appConfig.REACT_APP_GOHUNT_CMS_URL)}
        >
          Log Out
        </Button>
        <div
          onClick={() => props.toggleCoords}
          className={styles.disableCoords}
        >
          <p>Hide Feature & Map Coordinates</p>
          <Switch
            className="ghSwitch"
            uncheckedIcon={false}
            checkedIcon={false}
            offColor='#333333'
            onColor='#f37735'
            onHandleColor='#ffffff'
            offHandleColor='#ffffff'
            checked={props.hideCoords}
            onChange={() => props.toggleCoords(props.hideCoords)}
            width={40}
            height={24}
          />
        </div>
      </div>
    </SidebarBody>
  );
}

UserProfileContent.propTypes = {
  profile: PropTypes.object,
  appConfig: PropTypes.object,
  hideCoords: PropTypes.bool,
  //actions
  toggleCoords: PropTypes.func,
  logout: PropTypes.func,
  showKeyboardShortcuts: PropTypes.func,
};

export default connect((model) => {
  return {
    profile: model.user.profile,
    appConfig: model.app.config,
    hideCoords: model.app.hideCoords,
  };
}, actions)(UserProfileContent);
